import axios from "axios";

// Backend URL resolution:
// - Use REACT_APP_BACKEND_URL when it matches the current origin (dev / same-origin prod)
// - Otherwise fall back to relative URLs so the app works on any custom domain
//   served through the same ingress (e.g. contentbymax.at) without rebuilding.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return envUrl || "";
  if (!envUrl) return "";
  try {
    const envOrigin = new URL(envUrl).origin;
    if (envOrigin === window.location.origin) return envUrl;
    return ""; // different origin → use relative paths, same-origin via ingress
  } catch (_e) {
    return "";
  }
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const TOKEN_KEY = "cbm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setToken(null);
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
        if (!window.location.pathname.includes("/admin/login")) {
          window.location.href = "/admin/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
